import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { BrutalButton, BrutalInput } from "../components/brutal";
import { CompanionMascot } from "../components/CompanionMascot";
import { IconLeaf, IconSparkle } from "../components/HandDrawn";
import { useAuthStore } from "../store";
import { api } from "../lib/api";
import { toast } from "sonner";
import { PasswordField, PasswordChecklist } from "../components/PasswordField";

export default function Signup() {
 const [form, setForm] = useState({ org_name: "", name: "", email: "", password: "" });
 const [loading, setLoading] = useState(false);
 const setAuth = useAuthStore((s) => s.setAuth);
 const nav = useNavigate();

 const submit = async (e) => {
 e.preventDefault();
 setLoading(true);
 try {
 const { data } = await api.post("/auth/register", form);
 setAuth(data.token, data.user);
 toast.success("Welcome to the garden ");
 nav("/");
 } catch (err) {
 toast.error(err.response?.data?.detail || "Signup failed");
 } finally { setLoading(false); }
 };

 return (
 <div className="min-h-screen flex items-center justify-center p-6 paper-grain relative overflow-hidden"
 style={{ background: "transparent" }}>
 <div className="absolute top-8 left-8 opacity-40 floaty-1 pointer-events-none"><IconSparkle size={56} /></div>
 <div className="absolute bottom-16 right-14 opacity-40 floaty-2 pointer-events-none"><IconLeaf size={72} /></div>

 <div className="max-w-md w-full relative z-10">
 <div className="text-center mb-6">
 <div className="flex justify-center"><CompanionMascot state="idle" size={140} /></div>
 <h1 className="font-display text-4xl mt-2" style={{ color: "var(--cozy-primary-dark)" }}>Create your organization</h1>
 <p className="font-hand text-lg mt-1" style={{ color: "var(--cozy-muted)" }}>you'll be the first Admin — invite your team after</p>
 </div>

 <div className="bg-cozy-surface shadow-cozy-lg p-8" style={{ borderRadius: 28, border: "1px solid var(--cozy-border)" }}>
 <form onSubmit={submit} className="space-y-4">
 <div>
 <label className="text-xs font-semibold uppercase tracking-wider block mb-1.5" style={{ color: "var(--cozy-muted)" }}>Organization name</label>
 <BrutalInput data-testid="signup-org-name" required value={form.org_name} onChange={(e) => setForm({ ...form, org_name: e.target.value })} placeholder="Acme Inc." />
 </div>
 <div>
 <label className="text-xs font-semibold uppercase tracking-wider block mb-1.5" style={{ color: "var(--cozy-muted)" }}>Your name</label>
 <BrutalInput data-testid="signup-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="What can we call you?" />
 </div>
 <div>
 <label className="text-xs font-semibold uppercase tracking-wider block mb-1.5" style={{ color: "var(--cozy-muted)" }}>Work email</label>
 <BrutalInput data-testid="signup-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" />
 </div>
 <div className="space-y-2">
 <PasswordField id="signup-password" data-testid="signup-password" label="Password" required autoComplete="new-password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} placeholder="At least 8 characters" />
 <PasswordChecklist value={form.password} />
 </div>
 <BrutalButton data-testid="signup-submit" type="submit" color="primary" size="lg" className="w-full" disabled={loading}>
 {loading ? "One sec..." : "Plant your garden "}
 </BrutalButton>
 </form>
 <p className="text-center mt-5 text-sm" style={{ color: "var(--cozy-muted)" }}>
 Already have an account? <Link className="font-semibold text-cozy-primary-dark underline" to="/login" data-testid="link-login">Sign in</Link>
 </p>
 <p className="text-center mt-2 text-xs" style={{ color: "var(--cozy-muted)" }}>
 Got an invite link from your admin? Open it directly to join their organization.
 </p>
 </div>
 </div>
 </div>
 );
}
